<template>
  <div>
    <div v-if="noData =='false'">
      <!-- 返回 -->
      <topPart :rightPart="true"></topPart>
      <!-- 返回页 -->
      <!-- 签名 -->
      <div v-show="test" class="sign" style="position:fixed;top:0;z-index:9999;bottom:0">
        <signature @closePop="closePop" @saveImg="complete"></signature>
      </div>
      <!-- 签名结束 -->
      <div v-show="!test">
        <!-- 标题 -->
        <div class="list-block">
          <div class="list_block_title">
            <!--类型  -->
            <div class="titleStyle">提案</div>
            <!-- 类型结束 -->
            <!-- 标题 -->
            <div class="nameStyle">{{title}}</div>
            <!-- 标题结束 -->
          </div>
          <div class="list_block_ctn">
            <div class="conterStyle" v-html="content"></div>
            <div class="enclosureBox">
              <div class="box_left">
                <img class="qbz-icon" src="../../../assets/images/qbz_icon.png" />附件：
              </div>
              <div class="enclosureConter">
                <div v-for="(item,index) in fileList" :key="index" @click="fileOpenFn(item)">
                  <div class="van-ellipsis">
                    <a>{{item.fileName}}</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="dealine_date">截止日期：{{time}}</div>
        </div>
        <!-- 标题结束 -->

        <div class="proposal_ctn">
          <div class="title_second">
            <span></span>我的提案
          </div>
          <div>
            <div class="title_third">案由</div>
            <div class="ctn_third">{{causeOfAction}}</div>
          </div>
          <div>
            <div class="title_third">案据</div>
            <div class="ctn_third">{{accordingToInformation}}</div>
          </div>
          <div>
            <div class="title_third">方案</div>
            <div class="ctn_third">{{programme}}</div>
          </div>
        </div>

        <div class="proposal_title_32">
          <div>附议代表（{{num}}人)</div>
        </div>
        <!-- 逻辑操作 -->
        <div v-if="forTheFirstTime == 0">
          <!-- 展示签名 -->
          <!-- 附议代表结束 -->
          <!-- 签名 -->
          <!-- 签名 -->
          <div class="my_flex">
            <div class="sign_title">我的签名</div>
            <div v-if="imgData" class="resign">
              <img class="sign-img" :src="imgData" />
              <span @click="showPopup" class="resign-txt">重新签名</span>
            </div>
            <div v-else class="signature_edit" @click="showPopup">
              <div>
                <img src="@/images/edit.png" alt />
                <span class="no_singature">签名</span>
              </div>
            </div>
          </div>
          <!-- 签名结束 -->
          <button class="submit_btn" @click="saveData">保存</button>
          <!-- 签名结束 -->
          <!-- 展示签名结束 -->
        </div>
        <div v-else>
          <!-- 详情 -->
          <div class="my_flex">
            <div class="sign_title">我的签名</div>
            <div v-if="imgData" class="resign">
              <img class="sign-img" :src="imgData" />
              <!-- <span @click="showPopup" class="resign-txt">重新签名</span> -->
            </div>
            <!-- <div v-else class="signature_edit" @click="showPopup">
          <div>
            <img src="@/images/edit.png" alt />
            <span class="no_singature">签名</span>
          </div>
            </div>-->
          </div>
          <!-- 详情结束 -->
        </div>
        <!-- 逻辑操作结束 -->
      </div>
      <!-- 打开文件弹框 -->
      <van-popup
        :lock-scroll="true"
        v-model="openFileShow"
        round
        position="bottom"
        :style="{ height: '160px' }"
      >
        <div class="open_file">
          <div @click="openFileFn">打开文档</div>
          <div @click="copyOpen">复制下载链接</div>
          <div class="open_cancel" @click="cancelOpen">取消</div>
        </div>
      </van-popup>
      <!-- 打开文件弹框 结束-->
    </div>
    <page-none v-if="noData =='true'" />
  </div>
</template>

<script>
import topPart from "../../../components/topPart";
import moment from "moment";
import signature from "../../../components/signature.vue";
import { toast } from "@/common/api/api.js";
import pageNone from "../../../components/pageNone";
export default {
  components: {
    topPart,
    signature,
    pageNone,
  },
  data() {
    return {
      num: 0,
      accordingToInformation: "", //案据
      programme: "", //方案
      causeOfAction: "", //案由
      forTheFirstTime: "",
      imgData: "", //签名
      test: false,
      conter: "", //意见盒子
      id: this.$route.query.id,
      recordId: this.$route.query.recordId,
      signatureId: this.$route.query.signatureId,
      time: "",
      fileList: [],
      title: "",
      content: "",
      openFileShow: false,
      currentFile: {},
      noData: "",
    };
  },
  mounted() {
    //获取详情数据
    this.getDetails();
  },
  methods: {
    // 打开弹框
    fileOpenFn(item) {
      this.currentFile = item;
      this.openFileShow = true;
    },
    // 关闭弹框
    cancelOpen() {
      this.openFileShow = false;
    },
    // 复制
    copyOpen() {
      if (!this.currentFile.filePath) return;
      window.scrollTo(0, 0);
      let that = this;
      let aux = document.createElement("input");
      aux.setAttribute("value", this.currentFile.filePath);
      document.body.appendChild(aux);
      aux.select();
      document.execCommand("copy");
      aux.className = "aux";
      aux.style.display = "none";
      document.body.removeChild(aux);
      setTimeout(() => {
        toast(that, "复制成功", "success");
      }, 2000);
      this.cancelOpen();
    },
    // 打开文件
    openFileFn() {
      if (!this.currentFile.filePath) return;
      window.location.href = this.currentFile.filePath;
      this.cancelOpen();
    },
    getSaveData() {
      var obj = {
        id: this.signatureId,
        signatrue: this.imgData,
      };
      return obj;
    },
    saveDataFun(data, message) {
      toast(this, message, "success");
      setTimeout(() => {
        this.$router.go(-1);
      }, 800);
    },
    //保存数据
    saveData() {
      var obj = this.getSaveData();
      this.sendQuestion("supportSignatrueSubmit", obj, "saveDataFun");
    },
    complete(data) {
      if (data) {
        this.imgData = data;
        this.test = false;
      }
    },
    closePop() {
      this.test = false;
    },
    showPopup() {
      this.test = !this.test;
    },
    //获取详情参数
    getgetDetailsData() {
      var obj = {
        id: this.signatureId,
      };
      return obj;
    },
    //处理返回数据
    getDetailsFun(data, message) {
      this.forTheFirstTime = data.signature.statusp;
      if(data.signature.signatrue=='https://sinomis.oss-cn-beijing.aliyuncs.com/null' || data.signature.signatrue=='https://sinomis.oss-cn-beijing.aliyuncs.com/undefined'){
        this.imgData='' //解决没有签名图片时，显示错误的图片bug
      }else{
         this.imgData = data.signature.signatrue;
      }
      this.causeOfAction = data.record.reason;
      this.accordingToInformation = data.record.evidence;
      this.programme = data.record.proposal;
      //赋值图片
      this.fileList = data.demoraticFiles;
      //策略转换数据
      this.num = data.proposal.auditNum; //人数
      this.title = data.proposal.title; //赋值title
      this.content = data.proposal.content; //赋值内容content
      this.time = moment(data.proposal.endTime).format("YYYY-MM-DD HH:mm:ss"); //结束时间
    },
    //获取详情数据
    getDetails() {
      var obj = this.getgetDetailsData();
      this.sendQuestion("signatureDetail", obj, "getDetailsFun");
    },
    //后端发送请求函数
    sendQuestion(url, obj, fun) {
      this.centralControl.axios.centralControl(
        url,
        (res) => {
          const { message, code, data } = res;
          //请求返回 关闭加载页
          this.loading = false;
          if (code == 200) {
            this.noData = "false";
            this[fun](data, message);
          } else {
            this.noData = "true";
            console.log(res, "接口错误-");
          }
        },
        obj
      );
    },
  },
};
</script>

<style lang="stylus" type="stylesheet/stylus" scoped>
.resign-txt {
  font-style: normal;
  margin: auto 0;
}

.resign {
  flex: 1;
  text-align: center;
  display: flex;
}

.sign-img {
  // width: 60px;
  height: 60px;
  margin: auto;
}

.open_file {
  height: 100%;
  background: #F3F5F9;

  #copyBtn {
    cursor: pointer;
  }

  div {
    height: 50px;
    text-align: center;
    line-height: 50px;
    background: #FFF;
  }

  >div:nth-child(1) {
    border-bottom: 1px solid #EFEFF3;
  }

  .open_cancel {
    margin-top: 9px;
  }
}

.submit_btn {
  width: 90%;
  // border: 1px solid rgba(41, 189, 187, 1);
  border-radius: 10px;
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #fff;
  height: 44px;
  margin: 20px;
  line-height: 44px;
  background: #38C7C4;
}

.signature_edit {
  width: 252px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid rgba(41, 190, 188, 1);

  .no_singature {
    display: inline-block;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: rgba(41, 190, 188, 1);
    line-height: 22px;
  }

  img {
    width: 16px;
    margin-right: 4px;
  }
}

.my_flex {
  display: flex;
  align-items: center;
  background: #FFF;
  padding: 16px;
  justify-content: space-between;

  .sign_title {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: rgba(53, 53, 53, 1);
  }
}

.proposal_title_32 {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  color: rgba(53, 53, 53, 1);
  border-bottom: 1px solid #EFEFF3;
  padding: 16px 15px;
  background: #FFF;
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  span {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: rgba(41, 189, 187, 1);
    margin-right: 10px;
  }

  img {
    width: 22px;
  }
}

.proposal_ctn {
  padding: 16px;
  background: #FFF;
  margin-top: 10px;

  .title_second {
    display: flex;
    align-items: center;
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: bold;
    color: rgba(53, 53, 53, 1);
    position: relative;
    border-bottom: 1px solid #EFEFF3;
    padding-bottom: 16px;

    span {
      display: inline-block;
      width: 10px;
      height: 10px;
      background: #29BDBB;
      margin-right: 4px;
    }
  }

  .title_third {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: rgba(53, 53, 53, 1);
    padding: 15px 0 10px 0;
  }

  .ctn_third {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: rgba(135, 135, 135, 1);
    line-height: 20px;
    max-height: 150px;
    overflow-y: auto;
    word-break:break-all;
  }
}

.titleStyle {
  display: inline-block;
}

.dealine_date {
  width: 100%;
  height: 36px;
  background: rgba(255, 75, 75, 0.1);
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #FF4B4B;
  text-align: center;
  line-height: 36px;
}

.qbz-icon {
  width: 14px;
  height: 15px;
  margin-right: 5px;
}

.enclosureConter {
  flex: 1;
  min-width: 0;

  >div {
    line-height: 34px;
    border-bottom: 1px solid #EFEFF3;
  }

  >div:nth-last-child(1) {
    border: none;
  }

  a {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: rgba(86, 137, 240, 1);
  }
}

.enclosureBox {
  display: flex;
  align-items: center;
  // margin-top: 10px;
}

.enclosureTitle {
}

.titleStyle {
  padding: 4px 7px;
  border-radius: 20px;
  font-size: 11px;
  color: #fff;
  text-align: center;
  display: inline-block;
  margin: auto 0 auto 0;
  background: linear-gradient(103deg, rgba(79, 172, 254, 1), rgba(0, 242, 254, 1));
}

.nameStyle {
  width: 70%;
  margin-left: 1.8%;
  display: inline-block;
}

.list-block {
  background: #FFF;
  margin-top: 50px;
  height: auto !important;

  .list_block_title {
    padding: 16px;
    border-bottom: 1px solid #EFEFF4;
    display: flex;
  }

  .list_block_ctn {
    padding: 16px;
    .conterStyle{
      word-break:break-all;
    }
  }
}

.conterStyle {
  >>> img {
    max-width: 100%;
    margin-top: 4px;
  }

  >>> p, span {
    margin-top: 10px;
    font-size: 14px;
    line-height: 20px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: rgba(53, 53, 53, 1);
  }

  >>> p:nth-child(1) {
    margin-top: 0;
  }

  >>> ol, span, ol, li, ul, h1, h2, strong, em {
    display: inline-block;
  }

  >>> br {
    display: none;
  }
}

.suggest_color {
  background: linear-gradient(103deg, rgba(69, 209, 172, 1), rgba(39, 189, 186, 1));
}

.vote_color {
  background: linear-gradient(103deg, rgba(255, 19, 86, 1), rgba(255, 59, 142, 1), rgba(255, 19, 86, 1));
}
</style>